<template>
  <div>{{ $t('noRecords') }}</div>
</template>

<script>
  export default {
    name: 'EmptyReminder',
    locales: {
      zh: {
        noRecords: '没有邀请记录，请分享邀请好友'
      },
      en: {
        noRecords: 'No Invitation Records'
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";
  div {
    text-align: center;
    font-size: .14rem;
    line-height: .16rem;
    padding: .8rem 0 .4rem;
    color: #666;
    @media screen and (max-width: 767px) {
      padding: .4rem 0;
      font-size: .12rem;
    }
  }
</style>



// WEBPACK FOOTER //
// EmptyReminder.vue?8227e69e